// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAO5hHM4bDTz7csdE78MIb7ZGKhD1ctEIE",
  authDomain: "edtechclone12adminsection.firebaseapp.com",
  projectId: "edtechclone12adminsection",
  storageBucket: "edtechclone12adminsection.firebasestorage.app",
  messagingSenderId: "429283108322",
  appId: "1:429283108322:web:278ba05d8186ba048885bb"
};
// Initialize Firebase
const app = initializeApp(firebaseConfig);

const auth = getAuth(app);

export default auth;